import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { VIDEO_ATENCION } from '@constants/url.constant';
import { FirestoreService } from '@services/firestore/firestore.service';
import { IConfiguracionesTexto } from '@interfaces/reforma-configuraciones-texto.interface';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-ajuste-pension',
    templateUrl: './ajuste-pension.component.html',
    styleUrl: './ajuste-pension.component.scss',
    standalone: false
})
export class AjustePensionComponent {

  private readonly firestoreService = inject(FirestoreService);

  content$: Observable<IConfiguracionesTexto> = this.firestoreService
    .getDoc<IConfiguracionesTexto>('reforma-pensiones', 'configuraciones-texto');

  constructor(private readonly router: Router) { }

  goToVideoAtencion(): void {
    this.router.navigate([`/${VIDEO_ATENCION}`]);
  }
}